import { render, staticRenderFns } from "./quilleditor.vue?vue&type=template&id=018a72aa&"
import script from "./quilleditor.vue?vue&type=script&lang=js&"
export * from "./quilleditor.vue?vue&type=script&lang=js&"
import style0 from "./quilleditor.vue?vue&type=style&index=0&id=018a72aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports